<template>
  <el-dialog
    :visible.sync="visible"
    title="选择合作平台"
    :append-to-body="true"
    :destory-on-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="400px"
    @close="handleClose"
    @open="handleOpen"
  >
    <el-form
      ref="formRef"
      label-width="100px"
      :model.sync="formData"
      :rules="rules"
      label-position="top"
    >
      <el-form-item label="合作平台" prop="opts">
        <QS-select
          v-model="formData.opts"
          :optionData="options"
          :optionConfig="{
            valueKey: 'code',
            labelKey: 'name',
          }"
          filterable
          clearable
          multiple
          placeholder="请选择"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定选择</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'

const props = defineProps({
  value: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    default: () => [],
  },
})

const emits = defineEmits(['input', 'onChange'])

const visible = ref(false)
const formRef = ref(null)
const formData = ref({
  opts: [], // 初始化为空数组
})

// 修改 watch，确保及时更新内部状态
watch(() => props.value, (newVal) => {
  formData.value.opts = Array.isArray(newVal) ? [...newVal] : []
}, { immediate: true, deep: true })

const handleClose = () => {
  visible.value = false
  formData.value.opts = Array.isArray(props.value) ? [...props.value] : [] // 关闭时重置为 props 的值
  formRef.value?.clearValidate()
}

const handleSubmit = () => {
  formRef.value.validate(async (valid) => {
    if (!valid) return
    const newOpts = [...formData.value.opts]
    emits('input', newOpts)
    emits(
      'onChange',
      props.options.filter((item) => newOpts.includes(item.code)),
    )
    visible.value = false
  })
}


const rules = {}


const handleOpen = async () => {
  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

watch(() => props.value, () => {
  formData.value.opts = props.value
})

defineExpose({
  show: () => {
    formData.value.opts = Array.isArray(props.value) ? [...props.value] : [] // 打开时同步最新的 props 值
    visible.value = true
    formRef.value?.clearValidate()
  },
  close: handleClose,
})

</script>

<style lang="scss" scoped>
::v-deep {
  .el-select {
    width: 100%;
  }
}
</style>
